<template>
  <div class="wrap">
    <img class="banner" v-if="show" src="../../assets/images/signResult.png" alt />
    <p class="desc" v-if="show">实名认证失败</p>
    <a id="jump" href="" target="_blank" /> 
  </div>
</template>

<script>
  export default {
    data() {
      return {
        uid:'',
        platform:'',
        show:false,
      };
    },
    methods: {
      getUrlParam(name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
        var r = window.location.search.substr(1).match(reg);
        if (r != null) return unescape(r[2]);
        return null;
      },
      checkSignState() {
        let that =this
        this.$commonPost({
          jydm: "flow_10114",
          flow_10114: {
            uid: this.uid,
          }
        }).then(resp => {
          if(resp.resp_code == 0 && resp.resp_result == 0){
            if(resp.state=='1'){
              setTimeout(() => {
                that.checkSignState();
              }, 1000);
            }else if(resp.state=='2'){
              that.toSign()
            }else{
              that.show=true
              // this.$toast({
              //   message:'用户实名认证失败',
              //   duration: 2000,
              // })
            }
          }else{
            this.$toast({
              message: resp.resp_msg,
              duration: 2000
            });
          }
        }).catch(err => {
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
      },
      toSign(){
        const toast = this.$toast({
          type: "loading",
          message: "签约中",
          mask: true,
          duration: 0,
        });
        this.$post("/api/customer/ident/knightSign", {
          uid: this.uid,
          platform:this.platform,
        })
        .then((res) => {
          toast.clear();
          if (res.code == "200") {
            let resp = res.object.resp;
            if (resp.resp_code == "0" && resp.resp_result == "0") {
              window.location.href = resp.jumpUrl
            } else {
              this.$toast({
                message: resp.resp_msg,
                duration: 2000,
              });
            }
          } else {
            this.$toast({
              message: res.message,
              duration: 2000,
            });
          }
        })
        .catch((err) => {
          toast.clear();
          this.$toast({
            message: "您现在的网络不稳定，请稍后再试",
            duration: 2000,
          });
        });
      },
    },
    mounted() {
      document.title = '签约中';
      let uid = this.getUrlParam("uid");
      let platform = this.getUrlParam("platform");
      this.uid = uid
      this.platform = platform
      this.checkSignState()
    }
  };
</script>

<style scoped>
  .wrap {
    width: 100%;
    background: #fff;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 1.5rem;
    box-sizing: border-box;
  }
  .banner{
    width: 1.5rem;
    height: 1.54rem;
    margin-bottom: .34rem;
  }
  .desc{
    height: .42rem;
    line-height: .42rem;
    margin-bottom: .8rem;
    font-size: .3rem;
    color: #333;
    font-weight: 500;
  }
  #jump{
    overflow: hidden;
  }
</style>


// WEBPACK FOOTER //
// src/components/information/authResult.vue